import { breakpoints, ReactFCC, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const ActionCardWrapper = styled.div<{
  isUnderSelectBox?: boolean;
}>`
  position: relative;
  padding: 0.75rem;
  border-radius: 2px;

  background-color: ${theme.color.common.magenta95};

  margin: ${(props) =>
    props.isUnderSelectBox ? '0 0 0.75rem 0' : '0.75rem 0 0.75rem 0'};

  @media (min-width: ${breakpoints.md}) {
    margin: 1rem 0 0.75rem 0;
  }
`;

export const ActionCardInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2px;
`;

export const PictogramWrapper = styled.div`
  margin: 0 0 0 2rem;

  @media (min-width: ${breakpoints.sm}) {
    margin: 0 0 0 1rem;
  }

  @media (min-width: ${breakpoints.md}) {
    margin: 0 0 0 2.5rem;
  }

  z-index: 1;
  > div {
    font-size: 0.9rem;
    font-weight: 500;
    width: 3rem;
    height: 3rem;
    > span {
      margin: 0;
    }
  }
`;

export const PriceDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ActionPriceDescription = styled.div`
  color: ${theme.color.text.primary};
  ${theme.typography.labelSmall400}
`;

export const CurrencyWrapper = styled.span<{
  isSpaced: boolean;
  isPrefix: boolean;
}>`
  &:before {
    content: ${(props) => (props.isSpaced && !props.isPrefix ? '" "' : '')};
  }
  &:after {
    content: ${(props) => (props.isSpaced && props.isPrefix ? '" "' : '')};
  }
` as ReactFCC;

export const Slash = styled.span`
  padding: 0 0.25rem;
`;

export const DiscountAmountWrapper = styled.span`
  color: ${theme.color.text.highlight};
  ${theme.typography.titleMedium}
`;

export const TopIcon = styled.div`
  background-color: ${theme.color.background.highlight};
  color: ${theme.color.text.inverse};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Prices = styled.div`
  color: ${theme.color.text.highlight};
  ${theme.typography.titleMedium}
`;
